import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FormsModule, ReactiveFormsModule, FormBuilder, Validators } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'pixl-form-dialog-generic-tree',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSlideToggleModule,
    FormsModule,
    ReactiveFormsModule,
    TranslocoModule
  ],
  templateUrl: './form-dialog-generic-tree.component.html',
  styleUrl: './form-dialog-generic-tree.component.scss'
})
export class FormDialogGenericTreeComponent {
  private fb = inject(FormBuilder);
  private dialogRef = inject(MatDialogRef<FormDialogGenericTreeComponent>);
  public data = inject(MAT_DIALOG_DATA);

  form = this.fb.group({
    name: [this.data.genericTree.name || '', Validators.required],
    active: [this.data.genericTree.active ?? true]
  });

  onSave(): void {
    if (this.form.valid) {
      this.dialogRef.close({
        ...this.data.genericTree,
        ...this.form.value
      });
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
